// extracted by mini-css-extract-plugin
export var welcomeContent = "styles-module__welcomeContent___mADqX";
export var disclaimer = "styles-module__disclaimer___ZhQyu";
export var terms = "styles-module__terms___ryTZX";